import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { ApplicationService } from '../../services/apps.service';

import * as applicationsActions from '../actions/applications.actions';

@Injectable()
export class ApplicationsEffetcs {
  constructor(private actions$: Actions, private applicationService: ApplicationService) {}

  getApplications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(applicationsActions.LOAD_APPS),
      mergeMap(() =>
        this.applicationService.readApplications().pipe(
          map((applications) => applicationsActions.LOAD_APPS_SUCCESS({ applications })),
          catchError((err) => of(applicationsActions.LOAD_APPS_ERROR({ payload: err }))),
        ),
      ),
    ),
  );
}
